import { Guesses } from "../Guesses";
import { Panel } from "./Panel";
import React, { useState } from "react";
import { SettingsData } from "../../hooks/useSettings";


interface InfosProps {
	isOpen: boolean;
	close: () => void;
	settingsData: SettingsData;
}

export function Infos({ isOpen, close, settingsData }: InfosProps) {
	const [a, seta] = useState(0);
	const backgroundColour = "#33405C";
	return (
		<Panel title="Ofte stilte spørsmål" isOpen={isOpen} close={close}>

			<div id="accordion-collapse" data-accordion="collapse">
				<h2 id="accordion-collapse-heading-0">
					<button onClick={() => seta(a === 0 ? -1 : 0)} type="button" className="flex items-center justify-between w-full p-5 font-medium text-left text-gray-500 border border-b-0 border-gray-200 rounded-t-xl focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800" data-accordion-target="#accordion-collapse-body-1" aria-expanded="true" aria-controls="accordion-collapse-body-1">
						<span>Hva faen?</span>
						<svg data-accordion-icon className="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
							<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5" />
						</svg>
					</button>
				</h2>
				<div id="accordion-collapse-body-0" className={a === 0 ? "" : "hidden"} style={{ backgroundColor: backgroundColour }} aria-labelledby="accordion-collapse-heading-1">
					<div className="p-5 border border-b-0 border-gray-200 dark:border-gray-700 dark:bg-gray-900" style={{ backgroundColor: backgroundColour }}>
						<p className="mb-2 text-gray-500 dark:text-gray-400">Oslo</p>
					</div>
				</div>

				<h2 id="accordion-collapse-heading-1">
					<button onClick={() => seta(a === 1 ? -1 : 1)} type="button" className="flex items-center justify-between w-full p-5 font-medium text-left text-gray-500 border border-b-0 border-gray-200 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800" data-accordion-target="#accordion-collapse-body-2" aria-expanded="false" aria-controls="accordion-collapse-body-2">
						<span>Hvordan spiller man spillet?</span>
						<svg data-accordion-icon className="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
							<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5" />
						</svg>
					</button>
				</h2>
				<div id="accordion-collapse-body-1" className={a === 1 ? "" : "hidden"} style={{ backgroundColor: backgroundColour }} aria-labelledby="accordion-collapse-heading-2">
					<div className="p-5 border border-b-0 border-gray-200 dark:border-gray-700">
						<div className="space-y-3 text-justify border-b-2 border-gray-200 pb-3 mb-3">
							<div>
								Gjett riktig ikke-Oslo-by på seks forsøk. Hver gjetning må være en kulere by enn Oslo.</div>
							<div>
								Etter hver gjetning får du vite hvor langt unna du er og hvilken retning det korrekte stedet ligger relativ til den du har gjettet.
							</div>
						</div>
						<div className="space-y-3 text-justify border-b-2 border-gray-200 pb-3 mb-3">
							<div className="font-bold">Eksempel</div>
							<div>
								<Guesses
									rowCount={1}
									guesses={[
										{
											name: "Dabendorf",
											direction: "NW",
											distance: 1035000,
										},
									]} settingsData={settingsData} />
								<div className="my-2">
									Din første gjetning <span className="uppercase font-bold">Dabendorf</span> er
									1035km unna riktig sted, det riktige området ligger nordvestover.
								</div>
							</div>
							<div>
								<Guesses
									rowCount={1}
									guesses={[
										{
											name: "Trondheim",
											direction: "SW",
											distance: 431000,
										},
									]} settingsData={settingsData} />
								<div className="my-2">
									Din andre gjetning <span className="uppercase font-bold">Trondheim</span> er nærmere og
									431km unna riktig sted. Det riktige området ligger sørvestover.
								</div>
							</div>
							<div>
								<Guesses
									rowCount={1}
									guesses={[
										{
											name: "Stavanger",
											direction: "N",
											distance: 160000,
										},
									]} settingsData={settingsData} />
								<div className="my-2">
									Din tredje gjetning, <span className="uppercase font-bold">Stavanger</span> er kun 160km fra det korrekte svaret. Kanskje er det en annen fin by på Vestlandet du leter etter.
								</div>
							</div>
							<div>
								<Guesses
									rowCount={1}
									guesses={[
										{
											name: "Bergen",
											direction: "N",
											distance: 0,
										},
									]} settingsData={settingsData} />
								<div className="my-2">
									Din fjerde gjetning, <span className="uppercase font-bold">Bergen</span>,
									er riktig. Gratulerer! 🎉
								</div>
							</div>
						</div>
					</div>
				</div>

				<h2 id="accordion-collapse-heading-2">
					<button onClick={() => seta(a === 2 ? -1 : 2)} type="button" className="flex items-center justify-between w-full p-5 font-medium text-left text-gray-500 border border-gray-200 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800" data-accordion-target="#accordion-collapse-body-3" aria-expanded="false" aria-controls="accordion-collapse-body-3">
						<span>Hvordan måles distansen?</span>
						<svg data-accordion-icon className="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
							<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5" />
						</svg>
					</button>
				</h2>
				<div id="accordion-collapse-body-2" className={a === 2 ? "" : "hidden"} style={{ backgroundColor: backgroundColour }} aria-labelledby="accordion-collapse-heading-3">
					<div className="p-5 border border-t-0 border-gray-200 dark:border-gray-700">
						<p className="mb-2 text-gray-500 dark:text-gray-400">Distansen er den euklidske distansen mellom to midtpunkter til ikke-Oslo-byer. Den beregnes ikke fra grensen til byene. Man får derfor kun 0km som distanse dersom man finner det korrekte svaret.</p>
					</div>
				</div>

				<h2 id="accordion-collapse-heading-3">
					<button onClick={() => seta(a === 3 ? -1 : 3)} type="button" className="flex items-center justify-between w-full p-5 font-medium text-left text-gray-500 border border-gray-200 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800" data-accordion-target="#accordion-collapse-body-3" aria-expanded="false" aria-controls="accordion-collapse-body-3">
						<span>Hvem har lagt dette?</span>
						<svg data-accordion-icon className="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
							<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5" />
						</svg>
					</button>
				</h2>
				<div id="accordion-collapse-body-3" className={a === 3 ? "" : "hidden"} style={{ backgroundColor: backgroundColour }} aria-labelledby="accordion-collapse-heading-3">
					<div className="p-5 border border-t-0 border-gray-200 dark:border-gray-700">
						<p className="mb-2 text-gray-500 dark:text-gray-400">Hilsen fra Bergen</p>
					</div>
				</div>

				<h2 id="accordion-collapse-heading-4">
					<button onClick={() => seta(a === 4 ? -1 : 4)} type="button" className="flex items-center justify-between w-full p-5 font-medium text-left text-gray-500 border border-gray-200 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-800 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800" data-accordion-target="#accordion-collapse-body-3" aria-expanded="false" aria-controls="accordion-collapse-body-3">
						<span>Jeg har lyst å spille dette spillet med en ordentlig by. Hva skal jeg gjøre?</span>
						<svg data-accordion-icon className="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
							<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5" />
						</svg>
					</button>
				</h2>
				<div id="accordion-collapse-body-4" className={a === 4 ? "" : "hidden"} style={{ backgroundColor: backgroundColour }} aria-labelledby="accordion-collapse-heading-3">
					<div className="p-5 border border-t-0 border-gray-200 dark:border-gray-700">
						<p className="mb-2 text-gray-500 dark:text-gray-400">Du må gjerne se på <a href="https://www.bergle.no/" className="text-blue-600 dark:text-blue-500 hover:underline">Bergle</a>.</p>
					</div>
				</div>


			</div>

		</Panel>
	);
}
